import { createSliceSelector } from "../../util/store/selectors";
import { DISEASED_ZONE, InfoMode, propsEmpty } from "../../util/varibles/constants";
import { IOperation, IPosition } from "../../util/varibles/interface";

export enum TAB_OPERATION_DETAIL {
    INFO = 'info',
    MESSAGE = 'message'
}

export interface OperationDetailState {
    data: IOperation
    keyTab: TAB_OPERATION_DETAIL
    infoMode: InfoMode
    actualRoute: { real_route: { points: (IPosition & { time: number })[] }, route_diseases?: { type: DISEASED_ZONE, forskNr: string }[] }

    loadingOp: boolean
    loadingMessages: boolean
    loading: any

    loadingRoute: boolean
}

export const initialState: OperationDetailState = {
    data: propsEmpty,
    keyTab: TAB_OPERATION_DETAIL.INFO,
    infoMode: InfoMode.PLAN,
    actualRoute: { real_route: { points: [] } },

    loadingOp: false,
    loadingMessages: false,
    loading: { note: false },

    loadingRoute: false,
};

const { root, selector } = createSliceSelector(state => state.operationDetail);

export const selectOpDetail = {
    root,
    data: selector(s => s.data),
    operation: selector(s => s.data?.operation),
    infoMode: selector(s => s.infoMode),
    activityLog: selector(s => s.data?.activity_log),
    vessel: selector(s => s.data?.vessel),
    actualRoute: selector(s => s.actualRoute),
    loadingRoute: selector(s => s.loadingRoute),
    planRoute: selector(s => s.data?.route),
    loading: selector(s => s.loading),
};
